import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import '@/styles/element-variables.scss'
import 'font-awesome/css/font-awesome.css'
import 'simplemde/dist/simplemde.min.css'
import 'highlight.js/styles/github-dark.css'
import '@/styles/app.scss'
import '@/styles/fonts/fonts.css'

Vue.use(Element)

import * as directives from './directives'

Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

Vue.config.productionTip = false

new Vue({
  router, store, render: h => h(App)
}).$mount('#app')
